import React from 'react';
import './SupportTab.css';

const DISCORD_INVITE_URL = process.env.REACT_APP_DISCORD_INVITE;

const SupportTab = ({
  newTicketSubject,
  setNewTicketSubject,
  newTicketBody,
  setNewTicketBody,
  createTicket,
  tickets,
  ticketsLoading,
  openTicket,
  selectedTicket,
  ticketMessages,
  messageLoading,
  replyText,
  setReplyText,
  sendReply,
  ticketStatus,
  setTicketStatus,
  auth,
}) => {
  return (
    <div className="settings-card">
      <div className="support-header">
        <div>
          <h2>Support & Tickets</h2>
          <p className="settings-subtitle">
            Create a ticket and chat with the team. For urgent issues, Discord is usually faster.
          </p>
        </div>
        {DISCORD_INVITE_URL && (
          <a
            className="support-discord-btn"
            href={DISCORD_INVITE_URL}
            target="_blank"
            rel="noreferrer"
          >
            Open Discord
          </a>
        )}
      </div>

      <form className="settings-form support-form" onSubmit={createTicket}>
        <div className="settings-grid support-grid">
          <label className="support-field support-field--subject">
            <span className="support-label">Subject</span>
            <input
              className="support-input"
              value={newTicketSubject}
              onChange={(e) => setNewTicketSubject(e.target.value)}
              placeholder="Short title for your issue"
              required
            />
          </label>
          <label className="support-field support-field--message">
            <span className="support-label">Message</span>
            <textarea
              className="support-input support-textarea"
              value={newTicketBody}
              onChange={(e) => setNewTicketBody(e.target.value)}
              placeholder="Describe what happened, what you expected, and any screenshots or links."
              required
            />
          </label>
        </div>
        <div className="support-actions-row">
          <button className="settings-btn" type="submit">
            Submit ticket
          </button>
        </div>
      </form>

      <div className="tickets-list">
        {ticketsLoading && <p className="settings-status">Loading tickets...</p>}
        {tickets.map((t) => {
          const status = t.status || 'open';
          return (
            <button
              type="button"
              className={`ticket-row ticket-row--${status}`}
              key={t.id}
              onClick={() => openTicket(t)}
            >
              <div>
                <div className="ticket-title">{t.subject || 'Ticket'}</div>
                <div className="ticket-meta">
                  <span className={`ticket-status ticket-status--${status}`}>
                    {status === 'resolved' ? 'Resolved' : 'Open'}
                  </span>
                  <span className="ticket-meta-separator">•</span>
                  Updated:{' '}
                  {t.updatedAt?.seconds
                    ? new Date(t.updatedAt.seconds * 1000).toLocaleString()
                    : '-'}
                </div>
              </div>
              <span className="ticket-open-label">View</span>
            </button>
          );
        })}
        {tickets.length === 0 && !ticketsLoading && (
          <p className="settings-status">No tickets yet. Start by opening a ticket or reach out on Discord.</p>
        )}
      </div>

      {selectedTicket && (
        <div className="ticket-thread">
          <h3>{selectedTicket.subject}</h3>
          <div className="ticket-messages">
            {messageLoading && <p className="settings-status">Loading messages...</p>}
            {ticketMessages.map((m) => (
              <div className="ticket-msg" key={m.id}>
                <div className="ticket-msg-meta">
                  {m.senderUid === auth?.currentUser?.uid ? 'You' : 'Admin'} ·{' '}
                  {m.createdAt?.seconds
                    ? new Date(m.createdAt.seconds * 1000).toLocaleString()
                    : ''}
                </div>
                <div>{m.text}</div>
              </div>
            ))}
            {ticketMessages.length === 0 && !messageLoading && (
              <p className="settings-status">No messages yet.</p>
            )}
          </div>
          <form className="settings-form support-thread-form" onSubmit={sendReply}>
            <div className="support-thread-grid">
              <label className="support-field">
                <span className="support-label">Status</span>
                <select
                  className="support-input"
                  value={ticketStatus}
                  onChange={(e) => setTicketStatus(e.target.value)}
                >
                  <option value="open">Open</option>
                  <option value="resolved">Resolved</option>
                </select>
              </label>
              <label className="support-field support-field--message">
                <span className="support-label">Reply</span>
                <textarea
                  className="support-input support-textarea"
                  value={replyText}
                  onChange={(e) => setReplyText(e.target.value)}
                  placeholder="Type a reply"
                />
              </label>
            </div>
            <div className="support-actions-row">
              <button className="settings-btn" type="submit">
                Send reply
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default SupportTab;
